import { FormCol, FormRow, InfoTooltip, SafeHtml, TextControl, useScopedSelector } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledText, StyledTip, StyledList, StyledToolTipContainer } from './UsernameControl.styles';
import { Account } from '../../interfaces/Account';
import { AccountResourceInfo } from '../AccountResource';

export interface UsernameControlProps {
  isSubmitting: boolean;
}

const UsernameControl: FC<UsernameControlProps> = ({ isSubmitting }) => {
  const { t } = useTranslation('UsernameControl');
  const account: Account = useScopedSelector(AccountResourceInfo.dataDst);
  const validationMessage = useMemo(() => <SafeHtml>{account?.usernameFormatDescription}</SafeHtml>, [account?.usernameFormatDescription]);

  return (
    <FormRow>
      <FormCol label={`${t('title')}`} labelMarginBottom={36}>
        <>
          <StyledText>{t('label')}</StyledText>
          <StyledList>
            <li>{t('case1')}<StyledTip><StyledToolTipContainer><InfoTooltip trigger="focus" tip={validationMessage} /></StyledToolTipContainer></StyledTip></li>
            <li>{t('case2')}</li>
            <li>{t('case3')}</li>
          </StyledList>
          <TextControl
            maxErrorMessageRows={10}
            required
            disabled={isSubmitting}
            name="username"
            defaultValue={account?.username}
            minLength={account?.usernameMinLength}
            maxLength={account?.usernameMaxLength}
            validators={{
              format: (value: string) => account?.usernameRegex.test(value) || account?.usernameEmailRegex.test(value),
            }}
            validationMessages={{
              format: t('formatError'),
            }}
          />
        </>
      </FormCol>
    </FormRow>
  );
};

export default UsernameControl;
